var _path, _path2, _rect, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 7H22.1663V20.4166C22.1663 22.6718 20.3381 24.5 18.083 24.5H9.91633C7.66118 24.5 5.83301 22.6718 5.83301 20.4166V7Z",
    fill: "#D0D3DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 5.44436C4.6665 4.69264 5.27589 4.08325 6.02761 4.08325H21.972C22.7237 4.08325 23.3331 4.69264 23.3331 5.44436V6.99991H4.6665V5.44436Z",
    fill: "#697382"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.208,
    y: 9.91675,
    width: 2.33333,
    height: 10.5,
    fill: "#8A929E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.458,
    y: 9.91675,
    width: 2.33333,
    height: 10.5,
    fill: "#8A929E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 3.03335C11.9063 2.60124 12.3618 2.33325 12.8561 2.33325H15.1432C15.6375 2.33325 16.093 2.60124 16.333 3.03335L16.9163 4.08325H11.083L11.6663 3.03335Z",
    fill: "#697382"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cebdcfa0.svg";
export { ForwardRef as ReactComponent };